/**
 * The tenant's own entitlements + usage (ADR-0041 §10/§11) — the operator-plane source
 * for nav gating (show-locked-not-hidden) + usage badges. Auth-only; UNLIMITED off the
 * billed cloud (the backend resolver's no-op exemption).
 */
import { api } from "./api";

export interface LimitUsage {
  limit: number | null; // null = unlimited
  used: number | null; // null = not metered (e.g. the storage GAP)
}

export interface Entitlements {
  unlimited: boolean;
  features: Record<string, boolean>;
  limits: Record<string, LimitUsage>;
}

export const entitlementsApi = {
  get: () => api.get<Entitlements>("/entitlements"),
};
